import { createFileRoute } from "@tanstack/react-router";
import { asSearchString } from "@repo/utils/search-params";
import { getRouteApi, useNavigate } from "@tanstack/react-router";
import { ChevronRight, IdCard, MessageSquareLock } from "lucide-react";

export type F2ASearch = {
  biz?: string;
  redirect?: string;
};

export const Route = createFileRoute("/f2a/")({
  validateSearch: (search: Record<string, unknown>): F2ASearch => ({
    biz: asSearchString(search.biz),
    redirect: asSearchString(search.redirect),
  }),
  component: F2AMenu,
});


const routeApi = getRouteApi("/f2a/");

export default function F2AMenu() {
    const navigate = useNavigate();
    const { biz, redirect } = routeApi.useSearch();
    return (
        <div className={"min-h-screen flex flex-col bg-gray-100"}>
            <div className={"p-4 text-md"}>请选择身份验证方式</div>
            <div className={"flex flex-col"}>
                <F2ASelectItem title="短信验证码验证" icon={<MessageSquareLock />} onClick={() => navigate({ to: "/f2a/otp", search: { biz, redirect }, replace: true })} />
                <F2ASelectItem title="实名信息验证" icon={<IdCard />} onClick={() => navigate({ to: "/f2a/id", search: { biz, redirect }, replace: true })} />
            </div>
        </div>
    )
}


function F2ASelectItem({ title, icon, onClick }: { title: string, icon: React.ReactNode, onClick: () => void }) {
    return (
        <div className="flex flex-row items-center p-4 bg-white justify-between" onClick={onClick}>
            <span className={"text-md shrink-0 flex items-center gap-2"}>{icon} {title}</span>
            <ChevronRight />
        </div>
    );
}
